/**
 * ProviderTopBar — sits to the right of ProviderSidebar.
 *
 * Holds the business-name title (or a fallback greeting for fresh
 * provider profiles), a CertifiedBadge accent, and the AvatarDropdown
 * with role-switcher for multirole accounts.
 */
import React from "react";
import { Briefcase } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useConfig } from "@/context/ConfigContext";
import AvatarDropdown from "@/components/AvatarDropdown";
import ThemeToggle from "@/components/ThemeToggle";
import CertifiedBadge from "@/components/CertifiedBadge";

export default function ProviderTopBar() {
  const { user, providerProfile } = useAuth();
  const { providerDisplayLabel } = useConfig();
  const businessName = (providerProfile?.business_name || "").trim();
  const fallbackName = `Welcome, ${user?.name?.split(" ")[0] || providerDisplayLabel}`;
  const headerLabel = businessName || fallbackName;

  return (
    <header
      className="flex items-center justify-between border-b border-pp-border bg-pp-v3-bg px-8 py-4"
      data-testid="provider-shell-topbar"
    >
      <div className="flex items-center gap-3 min-w-0">
        <Briefcase className="h-6 w-6 text-pp-orange shrink-0" aria-hidden="true" />
        <h1
          className="font-heading text-2xl font-semibold text-pp-text truncate"
          data-testid="provider-shell-heading"
        >
          {headerLabel}
        </h1>
        <CertifiedBadge />
      </div>
      <div className="flex items-center gap-3">
        <ThemeToggle />
        <AvatarDropdown />
      </div>
    </header>
  );
}
